import { render, staticRenderFns } from "./connect-account.vue?vue&type=template&id=492f4919&scoped=true"
import script from "./connect-account.vue?vue&type=script&lang=js"
export * from "./connect-account.vue?vue&type=script&lang=js"
import style0 from "./connect-account.vue?vue&type=style&index=0&id=492f4919&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "492f4919",
  null
  
)

export default component.exports